import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

import { ControlsService } from './controls.service';
//import { NotificationsService } from 'angular2-notifications/dist';

import { AuthenticationService } from '../utils/authentication.service';
import { DataService } from './api.service';

@Component({
  selector: 'base',
  template: ''
})
export
  class BaseComponent implements AfterViewInit {
  protected param;
  data = [];
  public filterQuery = '';
  public rowsOnPage = 10;
  public sortBy = 'email';
  public sortOrder = 'asc';
  public notificationOptions = {
    position: ['top', 'right'],
    timeOut: 5000,
    lastOnBottom: true
  };
  clickedDashboardPos = 'hints';

  constructor(
    public dataService: DataService,
    public controlsService: ControlsService,
    //public notificationsService: NotificationsService,
    public router: Router,
    public authenticationService: AuthenticationService) {
  }

  
  ngAfterViewInit() {
    this.checkMsgsFromLocalStorage();
  }

  getList() {
    this.dataService.getList().subscribe(
      results => this.data = results.data,
      err => {
        if (err.status == 401)
          this.router.navigate(['sign-in'])
        else if (err.status == 404){
          this.data =[];
          this.showErrorMessage("Sorry, data not found.");
        }
        else {
          this.data = [];
          this.showErrorMessage(<string>err.message);
        }
      }
    );
  }

  remove(id: string) {
    this.dataService.delete(id).subscribe(
      data => this.data = data.data,
      err => {
        if (err.statusCode == 401)
          this.router.navigate(['sign-in'])
        else if (err.statusCode == 404){
          this.data =[];
          this.showErrorMessage("Sorry, data not found.");
        }
        else {
          this.data = [];
          this.showErrorMessage(<string>err.message);
        }
      });
  }

  save(obj) {
    let link;
    this.dataService.request$.subscribe(
      data => {
        link = data;
      }
    );
    if (obj._id === -1) {
      this.dataService.add(obj)
        .subscribe(
        results => this.router.navigate([`${link}`]),
        error => console.log(error)
        );
    } else {
      this.dataService.update(obj)
        .subscribe(
        results => this.router.navigate([`${link}`]),
        error => {
          if (error.statusCode != 401) {
            this.showErrorMessage(<string>error.message);
          }
        }
        );
    }
  }

  checkMsgsFromLocalStorage() {
    var message = JSON.parse(localStorage.getItem('notify'));
    if (message != undefined) {
      this.showSuccessMessage(<string>message.message);
      localStorage.removeItem('notify');
    }
  }

  /* Notyfications */
  showSuccessMessage(text: string) {
    // this.notificationsService.success(
    //   'SUCCESS',
    //   text,
    //   {
    //     showProgressBar: true,
    //     pauseOnHover: false,
    //     clickToClose: false,
    //     maxLength: 100
    //   }
    // )
  }

  showWarningMessage(text: string) {
    // this.notificationsService.warn(
    //   'WARNING',
    //   text,
    //   {
    //     timeOut: 5000,
    //     showProgressBar: true,
    //     pauseOnHover: false,
    //     clickToClose: false,
    //     maxLength: 100
    //   }
    // )
  }

  showErrorMessage(text: string) {
  //   this.notificationsService.error(
  //     'ERROR',
  //     text,
  //     {
  //       timeOut: 5000,
  //       showProgressBar: true,
  //       pauseOnHover: false,
  //       clickToClose: false,
  //       maxLength: 100
  //     }
  //   )
   }
}



// WEBPACK FOOTER //
// ./src/app/shared/base.component.ts